import React from 'react';
import OverviewDashboard from './OverviewDashboard';

import './overviewShow.css';

const OverviewShow = () => {
  return (
    <div style={{ width: '100%', padding: '0 8px' }}>
      <OverviewDashboard />
    </div>
  );
};

export default OverviewShow;
